let lockCount = 0;
let savedScrollY = 0;

export const lockPageScroll = () => {
  lockCount++;
  if (lockCount > 1) {
    return;
  }
  savedScrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${savedScrollY}px`;
  document.body.style.width = "100%"; //Prevents layout shift when scrollbar disappears
};

export const unlockPageScroll = () => {
  if (lockCount <= 0) {
    return;
  }
  lockCount--;
  if (lockCount > 0) {
    return;
  }
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";
  window.scrollTo({ top: savedScrollY, behavior: "instant" });
  savedScrollY = 0;
};
